// Value Object: AcademicYear
export class AcademicYear {
    private constructor(private readonly value: string) { }

    static create(value: string): AcademicYear {
        if (!/^\d{4}(\/|-)\d{4}$/.test(value)) {
            throw new Error("Invalid academic year format. Expected YYYY/YYYY or YYYY-YYYY.");
        }
        const normalizedValue = value.replace('-', '/');
        return new AcademicYear(normalizedValue);
    }

    getValue(): string {
        return this.value;
    }
}